// extracted by mini-css-extract-plugin
module.exports = {"actionButtons":"ApproveButton_actionButtons__3_y7n","approveButton":"ApproveButton_approveButton__3Tg0t"};